import axios, { type AxiosResponse } from 'axios';

import { type Reviews } from '../types/types';

export const fetchExternalProductReviewsFromUrl = async (productId: string): Promise<Reviews> => {
    const { data }: AxiosResponse<Reviews> = await axios.get('api/external/reviews', {
        params: {
            productId,
        },
    });

    return data;
};
